import React from "react";
import { framework_tool, component_tool, utils_tool } from '../../../../tool'
import { WizTableForm } from "../../../common";

let { WizDataTable, WizButton, WizPopover } = component_tool
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })


export default (self, type, info) => {
  let columns = []
  columns = columns.concat([
    {
      name: 'id',
    },
    {
      name: 'practiceId'
    }
  ])
  if (type !== 'allRank') {
    columns = columns.concat([
      {
        title: '日期',
        name: 'practiceDate',
        searchItem: {
          type: 'date~',
          format: 'YYYY-MM-DD'
        }
      },
      {
        title: '日期',
        name: 'practiceDate',
        tableItem: {}
      },
      {
        title: '参与用户(人)',
        name: 'participantNum',
        tableItem: {
          render: (text, record) => (
            <WizDataTable.Oper>
              <WizButton tooltip={text} onClick={e => self._onLook(record, e)}>
                {text}
              </WizButton>
            </WizDataTable.Oper>
          )
        }
      },
      {
        title: '未参与用户(人)',
        name: 'nonParticipantNum',
        tableItem: {}
      },
      {
        title: '参与人次',
        name: 'participantCount',
        tableItem: {}
      },
      {
        title: '操作',
        tableItem: {
          render: (text, record) => (
            <WizDataTable.Oper>
              <WizButton tooltip="查看排行" onClick={e => self._onLook(record, e)}>
                查看排行
              </WizButton>
            </WizDataTable.Oper>
          )
        }
      }
    ])
  } else {
    columns = columns.concat([
      {
        title: '总排名',
        name: 'rank',
        tableItem: {}
      },
      {
        title: '姓名',
        name: 'fullName',
        searchItem: {},
        tableItem: {}
      },
      {
        title: '账号',
        name: 'userName',
        searchItem: {},
        tableItem: {}
      },
      {
        title: '岗位',
        name: 'positionId',
        searchItem: {
          ...positionConfig,
          diy: WizTableForm,
          selectType: 'radio',
        },
      },
      {
        title: '组织',
        name: 'orgId',
        searchItem: {
          ...organizationConfig,
          diy: WizTableForm,
          selectType: 'radio',
        }
      },
      {
        title: '账号状态',
        name: 'accountState',
        tableItem: {},
        dict: [
          { code: 1, codeName: "激活" },
          { code: 0, codeName: "禁用" }
        ]
      },
      {
        title: '任职信息',
        name: 'userIdentityInfoList',
        tableItem: {
          width: 200,
          render: (val = [], record) => {
            if (!val.length) { return '暂无任职' }
            let { orgName, positionName } = val[0]
            let _titleView = [`${orgName}-${positionName}`]
            if (val.length > 1) {
              _titleView.push(<span className='manager-person-text-color'> ...</span>)
            }
            return (
              <WizPopover
                content={val.map((e) => <p>{`${e['orgName']}-${e['positionName']}`}</p>)}
                placement="rightTop"
              >
                {_titleView}
              </WizPopover>
            )
          }
        }
      },
      {
        title: '练习天数',
        name: 'days',
        tableItem: {}
      },
      {
        title: '练习次数',
        name: 'count',
        tableItem: {}
      },
      {
        title: '平均正确率',
        name: 'avgAccuracy',
        tableItem: {
          render: (text, record) => {
            return text + '%'
          }
        }
      },
      {
        title: '最优正确率',
        name: 'maxAccuracy',
        tableItem: {
          render: (text, record) => {
            return text + '%'
          }
        }
      },
      {
        title: '平均练习时长(秒)',
        name: 'avgDuration',
        tableItem: {}
      },
    ])
  }

  return columns
}
